import {
  UseMutateFunction,
  useMutation,
  UseMutationResult,
} from '@tanstack/react-query';
import { useDebounce } from '@uidotdev/usehooks';
import { Input, Modal, Spin } from 'antd';
import { AxiosResponse } from 'axios';
import { memo, useEffect, useState } from 'react';

import { SaleTeamApi } from 'apis/SaleTeamApi';
import { SaleTeamDetailApi } from 'apis/SaleTeamDetailApi';
import { Button } from 'components';
import {
  GetUserNotTS,
  IGetTeamSaleDetailById,
  IGetUserByPlantNotTeamSale,
  Item,
  User,
} from 'interfaces/TeamSale/TeamSale';
import { IParamsAddEmployee } from 'interfaces/TeamSaleDetail/TeamSaleDetail';
import { toastError, toastSuccess } from 'utils/constants/functions';
import { icons } from 'utils/constants/icons';

interface IProps {
  open: boolean;
  teamSale: Item | undefined;
  data: GetUserNotTS | null;
  setData: React.Dispatch<React.SetStateAction<GetUserNotTS | null>>;
  setOpen: (open: boolean) => void;
  // updateInfoTeamSale: UseMutateFunction<
  //   AxiosResponse<any, any>,
  //   Error,
  //   any,
  //   unknown
  // >;
  refetch({ afterMutation }: { afterMutation?(items: Item[]): void }): void;
  getTSById: UseMutationResult<
    AxiosResponse<any, any>,
    Error,
    IGetTeamSaleDetailById & {
      nextMutate?: UseMutateFunction<
        AxiosResponse<any, any>,
        Error,
        any,
        unknown
      >;
    },
    unknown
  >;
}

const { PlusOutlined, MinusOutlined } = icons;

const ModalMembers = ({
  open,
  teamSale,
  data,
  setData,
  setOpen,
  refetch,
  getTSById,
}: IProps) => {
  const [inputValue, setInputValue] = useState<string>('');

  const searchDebounce = useDebounce(inputValue, 500);
  const [selectedEmployees, setSelectedEmployees] = useState<any>([]);

  const {
      isPending: isGetEmployeesLoading,
      mutate: getEmployeesByPlantNotTeamSale,
    } = useMutation({
      mutationFn: (params: IGetUserByPlantNotTeamSale) =>
        SaleTeamApi.getUserByPlantId(params),
      onSuccess: (res) => {
        const filteredUsers = res.data.getUser.items.filter(
          (user: User) =>
            !selectedEmployees.some(
              (selected: User) => selected.id === user.id,
            ),
        );
        setData({
          ...res.data.getUser,
          items: filteredUsers,
        });
      },
      onError: (error) => {
        console.log(error);
      },
    }),
    { isPending: isAddEmployeePeding, mutate: addEmployee } = useMutation({
      mutationFn: (params: IParamsAddEmployee[]) =>
        SaleTeamDetailApi.createManyTeamSaleDetail(params),
      onSuccess: (res) => {
        if (typeof teamSale === 'undefined') {
          toastError('Thêm nhân viên không thành công!');
          return;
        }

        if (res.data.createManyTeamSalesDetail) {
          toastSuccess('Thêm nhân viên thành công!');

          // getTSById.mutate({
          //   teamSaleId: teamSale.id,
          //   nextMutate: updateInfoTeamSale,
          // });
          getTSById.mutate({ teamSaleId: teamSale.id });
          refetch({});
          getEmployeesByPlantNotTeamSale({
            plantId: teamSale.plantId,
            notInTeamSale: teamSale.id,
          });
          setInputValue('');
        }
      },
      onError: (error) => {
        toastError(`Thêm nhân viên không thành công!. ${error.message}`);
      },
    });
  // { isPending: isUpdateInfoTeamSale, mutate: updateInfoTeamSale } =
  //   useMutation({
  //     mutationFn: (params: any) => SaleTeamApi.updateSaleTeam(params),
  //     onSuccess: (res) => {
  //       if (res.data) getTeamSales();
  //     },
  //     onError: (error) => {
  //       getTeamSales();
  //       console.log(error);
  //     },
  //   });
  // { isPending: isSearchEmployeePeding, mutate: searchEmployee } = useMutation(
  //   {
  //     mutationFn: (param: string) => UserApi.getUsersNotTeamSale(param),
  //     onSuccess: (res) => {
  //       setData(res.data.getUser);
  //     },
  //     onError: (error) => {
  //       console.log(error);
  //     },
  //   },
  // );

  const handleAddEmployee = (selectedEmployees: User[]) => {
    if (selectedEmployees.length === 0) {
      toastError('Vui lòng chọn ít nhất một nhân viên để thêm vào đội.');
      return;
    }

    const params: IParamsAddEmployee[] = selectedEmployees.map((user) => ({
      userId: user.id,
      teamSaleId: teamSale?.id,
      sloc: user?.sloc,
    }));

    addEmployee(params);

    setSelectedEmployees([]);
    setOpen(false);
  };

  useEffect(() => {
    if (!open) return;

    if (data) {
      const filteredUsers = data.items.filter(
        (user: User) =>
          !selectedEmployees.some((selected: User) => selected.id === user.id),
      );
      setData({
        ...data,
        items: filteredUsers,
      });
    }
  }, [selectedEmployees]);

  useEffect(() => {
    if (!open || typeof teamSale === 'undefined') return;

    getEmployeesByPlantNotTeamSale({
      plantId: teamSale.plantId,
      notInTeamSale: teamSale.id,
    });
  }, [open]);

  useEffect(() => {
    if (!open) return;

    handleSearch();
  }, [searchDebounce]);

  const handleSearch = () => {
    getEmployeesByPlantNotTeamSale({
      plantId: teamSale?.plantId,
      notInTeamSale: teamSale?.id,
      searchValue: searchDebounce.trim(),
    });
  };

  const handleCancelModal = () => {
    setOpen(false);
    setInputValue('');
  };
  const moveEmployeeToSelected = (user: any) => {
    setSelectedEmployees((prev: any) => [...prev, user]);
    setData((prev: any) => ({
      ...prev,
      items: prev?.items.filter((item: any) => item.id !== user.id) || [],
    }));
  };

  const removeEmployeeFromSelected = (user: any) => {
    setSelectedEmployees((prev: any) =>
      prev.filter((selected: any) => selected.id !== user.id),
    );
    setData((prev: any) => ({
      ...prev,
      items: [...(prev?.items || []), user],
    }));
  };

  return (
    <Modal
      footer={null}
      title="Danh sách nhân viên chưa có đội"
      centered
      open={open}
      onOk={handleCancelModal}
      onCancel={handleCancelModal}
      width={1150}
      className="relative"
    >
      <Input.Search
        allowClear
        className="mb-3"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Tìm kiếm...."
        onSearch={handleSearch}
        onPressEnter={handleSearch}
      />
      <Spin
        spinning={
          isGetEmployeesLoading || isAddEmployeePeding || getTSById.isPending
        }
      >
        <div className="flex h-96 relative">
          <div className="flex-1 overflow-y-auto pr-4">
            <h3 className="mb-2 font-bold">Nhân viên chưa có đội</h3>
            <div className="grid grid-cols-2 gap-3">
              {data?.items.map((user) => (
                <div key={user.id} className="flex items-start gap-3 py-3">
                  <Button
                    handleOnclick={() => moveEmployeeToSelected(user)}
                    title={<PlusOutlined />}
                  />
                  <div>
                    <p>
                      <b>Mã nhân viên:</b> {user.id}
                    </p>
                    <p>
                      <b>Tên nhân viên:</b> {user.fullName}
                    </p>
                    <p>
                      <b>Email:</b> {user.email}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="w-px bg-gray-300 absolute top-0 bottom-0 left-1/2 transform -translate-x-1/2"></div>
          <div className="flex-1 overflow-y-auto pl-4">
            <h3 className="mb-2 font-bold">Nhân viên đã chọn</h3>
            <div className="grid grid-cols-2 gap-3">
              {selectedEmployees.map((user: any) => (
                <div key={user.id} className="flex items-start gap-3 py-3">
                  <Button
                    handleOnclick={() => removeEmployeeFromSelected(user)}
                    title={<MinusOutlined />}
                  />
                  <div>
                    <p>
                      <b>Mã nhân viên:</b> {user.id}
                    </p>
                    <p>
                      <b>Tên nhân viên:</b> {user.fullName}
                    </p>
                    <p>
                      <b>Email:</b> {user.email}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-4 flex justify-end">
          <Button
            title="Lưu"
            handleOnclick={() => handleAddEmployee(selectedEmployees)}
            fill
          />
        </div>
      </Spin>
    </Modal>
  );
};

export default memo(ModalMembers);
